// test1098
(1098 && 0);
